export default __webpack_public_path__ + "static/media/BrainBreak cards88.c0e2ef33.png";